/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon, Label, Placeholder } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const WaitingForCourier = () => {
    const [t] = useTranslation()

    return (
        <div css={css`
            position: relative;
            border-radius: 12px;
            overflow: hidden;
        `}>
            <div css={css`
                display: flex;
                align-items: center;
                gap: 1rem;
                padding: 0;
            `}>
                <div>
                    <div css={css`
                        width: 50px;
                        height: 50px;
                        background-color: white;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    `}>
                        <Icon name="user" size="large" color="grey" />
                    </div>
                </div>

                <div css={css`
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                `}>
                    <div css={css`
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 4px;
                    `}>
                        <div css={css`width: 100px;`}>
                            <Placeholder css={css`
                                &.ui.placeholder {
                                    margin: 0;
                                }
                                &.ui.placeholder .header .line {
                                    background-color: rgba(120, 120, 120, 0.5);
                                    height: 1rem;
                                    margin-bottom: 0;
                                }
                            `}>
                                <Placeholder.Header>
                                    <Placeholder.Line length='medium' />
                                </Placeholder.Header>
                            </Placeholder>
                        </div>

                        <div css={css`width: 80px;`}>
                            <Placeholder css={css`
                                &.ui.placeholder {
                                    margin: 0 4px 0 0;
                                }

                                &.ui.placeholder .header .line {
                                    background-color: rgba(0, 128, 128, 0.2);
                                    height: 0.9rem;
                                    border-radius: 4px;
                                    margin-bottom: 0;
                                }
                            `}>
                                <Placeholder.Header>
                                    <Placeholder.Line length='short' />
                                </Placeholder.Header>
                            </Placeholder>
                        </div>
                    </div>

                    <div css={css`
                        display: flex;
                        align-items: center;
                        gap: 5px;
                        color: grey;
                        font-size: 0.9rem;
                    `}>
                        <Icon name="phone" size="small" />
                        <span css={css`
                            display: inline-block;
                            width: 100px;
                            height: 14px;
                            background-color: rgba(150, 150, 150, 0.4);
                            border-radius: 2px;
                        `}></span>
                    </div>
                </div>
            </div>

            <div css={css`
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                backdrop-filter: blur(4px);
                background-color: rgba(255, 255, 255, 0.35);
                border: 1px solid rgba(255, 255, 255, 0.18);
                box-shadow: 0 8px 32px rgba(0, 128, 128, 0.1);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 1;
            `}>
                <Label
                  basic
                  color='teal'
                  size='large'
                >
                    {t('order.delivery.waiting_for_courier')}
                </Label>
            </div>
        </div>
    );
};

export { WaitingForCourier };
